import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PERIOD_PRESETS } from "./dashboardFilters";

const openPicker = (e) => { try { e.target.showPicker && e.target.showPicker(); } catch (err) { console.debug("showPicker indisponível", err); } };

function FilterSelect({ label, value, onChange, testId, allLabel, options }) {
  return (
    <div><Label className="text-xs">{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId}><SelectValue/></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{allLabel}</SelectItem>
          {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select></div>
  );
}

const STATUS_OPTS = [
  { value: "concluida", label: "Concluídas" }, { value: "cancelada", label: "Canceladas" }, { value: "remarcar", label: "Remarcadas" },
  { value: "em_transito", label: "Em Trânsito" }, { value: "pendentes", label: "Pendentes" },
];
const toOpts = (list) => list.map((x) => ({ value: x.id, label: x.nome }));

// Card de filtros do Dashboard: atalhos de período + De/Até + status/tipo/entregador/região/bairro.
export function DashboardFiltersCard({ filters, setFilters, activePeriod, onApplyPeriod, onClear, filtrosAtivos, entregadores, regioes, tipos, bairrosFiltrados }) {
  const patch = (p) => setFilters({ ...filters, ...p });
  return (
    <Card>
      <CardHeader className="pb-3 flex flex-row justify-between items-center gap-2 flex-wrap">
        <CardTitle className="text-base">Filtros</CardTitle>
        <div className="flex gap-1 items-center flex-wrap" data-testid="dash-period-presets">
          <span className="text-xs text-muted-foreground mr-1">Período:</span>
          {PERIOD_PRESETS.map((p) => (
            <Button key={p.key} size="sm" variant={activePeriod === p.key ? "default" : "outline"}
              onClick={() => onApplyPeriod(p.key)} data-testid={`dash-period-${p.key}`} aria-pressed={activePeriod === p.key}
              className={`h-7 text-xs ${activePeriod === p.key ? "bg-orange-600 hover:bg-orange-700" : ""}`}>
              {p.label}
            </Button>
          ))}
        </div>
      </CardHeader>
      <CardContent className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
        <div><Label className="text-xs">De</Label>
          <Input type="date" value={filters.start} onChange={(e) => patch({ start: e.target.value })} onClick={openPicker} data-testid="dash-start"/></div>
        <div><Label className="text-xs">Até</Label>
          <Input type="date" value={filters.end} onChange={(e) => patch({ end: e.target.value })} onClick={openPicker} data-testid="dash-end"/></div>
        <FilterSelect label="Status" value={filters.status} onChange={(v) => patch({ status: v })} testId="dash-status" allLabel="Todas" options={STATUS_OPTS} />
        <FilterSelect label="Tipo de Entrega" value={filters.tipo_id} onChange={(v) => patch({ tipo_id: v })} testId="dash-tipo" allLabel="Todos" options={toOpts(tipos)} />
        <FilterSelect label="Entregador" value={filters.entregador_id} onChange={(v) => patch({ entregador_id: v })} testId="dash-entregador" allLabel="Todos" options={toOpts(entregadores)} />
        <FilterSelect label="Região" value={filters.regiao_id} onChange={(v) => patch({ regiao_id: v, bairro_id: "all" })} testId="dash-regiao" allLabel="Todas" options={toOpts(regioes)} />
        <FilterSelect label="Bairro" value={filters.bairro_id} onChange={(v) => patch({ bairro_id: v })} testId="dash-bairro" allLabel="Todos" options={toOpts(bairrosFiltrados)} />
        <div className="flex items-end">
          <Button variant="ghost" onClick={onClear} disabled={!filtrosAtivos} className="w-full" data-testid="dash-clear">Limpar</Button>
        </div>
      </CardContent>
    </Card>
  );
}
